import React, { Component } from 'react'
import Seo from "./Seo"
import Footer from './Footer'


 class TermsConditions extends Component {
  render() {
    return (
      <div>
        <div className='container mt-5'>
          <h1 className='py-5'>Terms And Conditions</h1>
          <p>``All the forces in the world are not so powerful as an idea whose time has come’’
            – Victor Hugo More than it inspired us, it upheld our conviction to take the plunge.
            So took the birth of Pulse Labs!<br></br></p>
            <h4>Our Pulse…</h4>
            <p>Life for us at Pulse Labs is about thriving on ideas and insights that are ground-breaking.
               Contradictory it may sound, but our people with diverse mind-sets makes this task more easily. 
               What we have in common is the vision and passion for excellence. Outcome is in the form of solutions
                that are futuristic. For us, Innovation means Life. Welcome to Pulse Labs!<br></br></p>
                <h4>The Market Pulse…</h4> <p>Financial Advisory Profession in India is moving to its next level.
            The transition is as much challenging as exciting. Dwindling commissions has forced Financial
            Advisors to look at alternate revenue models. Regulatory Oscillations, Irrational Client Behaviour,
            Volatile Markets are adding to their woes.<br></br></p>
            <h4>The Business Pulse…</h4>
            <p>Pulse Labs as a Business House cater to the B2B segment in the Financial Services space.
               We focus on creating solutions cemented with Technology, Research & Analytics, which are 
               best suited for the GenNext Advisory Firm. We offer this as APIs to FinTechs and Apps to IFAs (RIAs & MFDs)</p>
        </div>
        <Footer/>
        <Seo />
      </div>
    )
  }
}

export default  TermsConditions